
import 'leaflet/dist/leaflet.css';
import Title from "@/components/partials/elements/Title.vue";

export default {
  components: {Title},
  props: ['customStyle', 'mapOptions', 'airports'],
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      center: [51.505, -0.159],
      data: [],
      zoom: 3
    };
  },
  computed: {
    coordinates() {
      let coordinates = [];
      this.airportOnly.forEach((airport) => {
        if (airport.type === 'airport')
          coordinates.push([airport.geo.coordinates[1], airport.geo.coordinates[0]]);
      });
      return coordinates;
    },
    airportOnly() {
      return this.airports.filter((airport) => {
        return airport.type === 'airport';
      });
    }
  },
  methods: {
    onReady() {
      if (this.coordinates.length) {
        this.$refs.map.mapObject.fitBounds(this.coordinates);
      }
    },
  }
}
